<template>
    <div class="threshold">
        <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
            <el-main>
                <nav-bar></nav-bar>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="$t('MeterThresholdSetting')" name="first">
                        <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
                            <areaSelect :level="level" :deviceType="deviceType" :formArea="formArea" :enablesys="'1'"   @areaList="getAreaList"></areaSelect>
                            <el-form-item>
                                <el-button @click="getData" type="primary">{{ $t('Query') }}</el-button>
                                <el-button @click="reset">{{ $t('Reset') }}</el-button>
                            </el-form-item>
                        </el-form>
                        <template>
                            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add"
                                       v-if="judge('Notification_Create')"
                                       style="margin-bottom:10px;">{{ $t('SetMeterThreshold') }}
                            </el-button>
                            <el-table ref="multipleTable"
                                      :data="tableData1"
                                      border
                                      stripe
                                      style="width:100%;min-height:200px;">
                                <el-table-column fixed="left"
                                                 type="index"
                                                 :label="$t('SN')"
                                                 width="50">
                                </el-table-column>
                                <el-table-column fixed="left"
                                                 prop="deviceCode"
                                                 :label="$t('ElectricityMeterCode')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column prop="deviceName"
                                                 :label="$t('ElectricityMeterName')"
                                                 width="100">
                                </el-table-column>
                                <el-table-column :label="$t('PowerFactor')" align="center">
                                    <el-table-column prop="PowerUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.PF.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="PowerUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.PF.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="PowerLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.PF.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="PowerLowerL2"
                                                     :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.PF.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="$t('InstantaneousTotalPowerThreshold') + '(KW)'" align="center">
                                    <el-table-column prop="PowerUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.W.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="PowerUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.W.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="PowerLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.W.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="PowerLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.W.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="$t('PhaseACurrent') + '(A)'" align="center">
                                    <el-table-column prop="AElectricUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ia.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="AElectricUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ia.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="AElectricLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ia.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="AElectricLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ia.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="$t('PhaseBCurrent') + '(A)'" align="center">
                                    <el-table-column prop="BElectricUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ib.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="BElectricUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ib.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="BElectricLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ib.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="BElectricLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ib.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="$t('PhaseCCurrent') + '(A)'" align="center">
                                    <el-table-column prop="CElectricUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ic.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="CElectricUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ic.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="CElectricLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ic.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="CElectricLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ic.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="$t('PhaseAVoltage') + '(V)'" align="center">
                                    <el-table-column prop="AVoltageUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">Uan
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Uan.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="AVoltageUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Uan.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="AVoltageLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Uan.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="AVoltageLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Uan.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="$t('PhaseBVoltage') + '(V)'" align="center">
                                    <el-table-column prop="BVoltageUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ubn.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="BVoltageUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ubn.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="BVoltageLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ubn.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="BVoltageLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ubn.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="$t('PhaseCVoltage ') + '(V)'" align="center">
                                    <el-table-column prop="CVoltageUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ucn.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="CVoltageUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ucn.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="CVoltageLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ucn.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="CVoltageLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ucn.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="$t('ApparentPower') + '(KVA)'" align="center">
                                    <el-table-column prop="LoadPowerUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.S.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="LoadPowerUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.S.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="LoadPowerLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.S.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="LoadPowerLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.S.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <!-- <el-table-column :label="$t('AccumulatedConsumptionThreshold') + '(EP)'" align="center">
                                    <el-table-column prop="TotalPowerUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ep.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="TotalPowerUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ep.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="TotalPowerLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ep.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="TotalPowerLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Ep.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column> -->

                                <el-table-column :label="$t('ThreephaseUnbalanceThreshold') + '(%)'" align="center">
                                    <el-table-column prop="ImbaUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label v-if="scope.row.dataValue.Imba">{{scope.row.dataValue.Imba.upOne}}</label>


                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="ImbaUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label v-if="scope.row.dataValue.Imba">{{scope.row.dataValue.Imba.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="ImbaLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label v-if="scope.row.dataValue.Imba">{{scope.row.dataValue.Imba.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="ImbaLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label v-if="scope.row.dataValue.Imba">{{scope.row.dataValue.Imba.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>

                                <el-table-column :label="$t('ThreephaseUnbalanceCurrentConditionThreshold') + '(%)'" align="center">
                                    <el-table-column prop="ImbaCUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label v-if="scope.row.dataValue.ImbaC">{{scope.row.dataValue.ImbaC.upOne}}</label>


                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="ImbaCUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label v-if="scope.row.dataValue.ImbaC">{{scope.row.dataValue.ImbaC.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="ImbaCLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label v-if="scope.row.dataValue.ImbaC">{{scope.row.dataValue.ImbaC.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="ImbaCLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label v-if="scope.row.dataValue.ImbaC">{{scope.row.dataValue.ImbaC.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>

                                <el-table-column fixed="right"
                                                 :label="$t('Action')"
                                                 width="180">
                                    <template slot-scope="scope">
                                        <el-button v-if="judge('Notification_Update')" @click="editInfo(scope.row)" type="primary" size="small">
                                          {{ $t('Edit') }}
                                        </el-button>
                                        <template v-if="judge('Notification_Delete')">
                                            <el-popconfirm placement="top"
                                                           :confirmButtonText="$t('Delete')"
                                                           :cancelButtonText="$t('Cancel')"
                                                           @onConfirm="delData(scope.row.notificationObject)"
                                                           icon="el-icon-info"
                                                           iconColor="red"
                                                           :title="$t('DeleteConfirm')">
                                                <el-button size="mini" type="danger" slot="reference"
                                                           style="margin-left: 10px;">{{ $t('Delete') }}
                                                </el-button>
                                            </el-popconfirm>
                                        </template>
                                    </template>
                                </el-table-column>
                            </el-table>

                        </template>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('THThresholdSetting')" name="second">
                        <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
                            <areaSelect :level="level" :deviceType="deviceType" :formArea="formArea" :enablesys="'1'" @areaList="getAreaList"></areaSelect>
                            <el-form-item>
                                <el-button @click="getData" type="primary">{{ $t('Query') }}</el-button>
                                <el-button @click="reset">{{ $t('Reset') }}</el-button>
                            </el-form-item>
                        </el-form>
                        <template>
                            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add"
                                       v-if="judge('Notification_Create')"
                                       style="margin-bottom:10px;">{{ $t('SetTheThreshold') }}
                            </el-button>
                            <!--                            <el-button type="success" icon="el-icon-download" style="margin-bottom:10px;">导出Excel-->
                            <!--                            </el-button>-->

                            <el-table ref="multipleTable"
                                      :data="tableData2"
                                      border
                                      stripe
                                      style="width:100%;min-height:200px;">
                                <el-table-column fixed="left"
                                                 type="index"
                                                 :label="$t('SN')"
                                                 width="50">
                                </el-table-column>
                                <el-table-column fixed="left"
                                                 prop="deviceCode"
                                                 :label="$t('THMeterCode')"
                                                 width="130">
                                </el-table-column>
                                <el-table-column prop="deviceName"
                                                 :label="$t('THMeterName')"
                                                 width="130">
                                </el-table-column>
                                <el-table-column :label="$t('TemperatureThreshold')" align="center">
                                    <el-table-column prop="TUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Temp.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="TUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Temp.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="TLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Temp.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="TLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Temp.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="$t('HumidityThreshold')" align="center">
                                    <el-table-column prop="HUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Hum.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="HUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Hum.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="HLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Hum.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="HLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="80">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.Hum .downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column
                                                 :label="$t('Action')"
                                                 width="150">
                                    <template slot-scope="scope">
                                        <el-button v-if="judge('Notification_Update')" @click="editInfo(scope.row)" type="primary" size="small">
                                          {{ $t('Edit') }}
                                        </el-button>
                                        <template v-if="judge('Notification_Delete')">
                                            <el-popconfirm placement="top"
                                                           :confirmButtonText="$t('Delete')"
                                                           :cancelButtonText="$t('Cancel')"
                                                           @onConfirm="delData(scope.row.notificationObject)"
                                                           icon="el-icon-info"
                                                           iconColor="red"
                                                           :title="$t('DeleteConfirm')">
                                                <el-button size="mini" type="danger" slot="reference"
                                                           style=" margin-left: 10px;">{{ $t('Delete') }}
                                                </el-button>
                                            </el-popconfirm>
                                        </template>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-tab-pane>

                     <el-tab-pane :label="$t('LabPUEThresholdSetting')" name="third">
                        <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
                            <areaSelect :level="level" :deviceType="deviceType" :formArea="formArea" :enablesys="'1'" :comType="'LabPue'" @areaList="getAreaList"></areaSelect>
                            <el-form-item>
                                <el-button @click="getData" type="primary">{{ $t('Query') }}</el-button>
                                <el-button @click="reset">{{ $t('Reset') }}</el-button>
                            </el-form-item>
                        </el-form>
                        <template>
                            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add"
                                       v-if="judge('Notification_Create')"
                                       style="margin-bottom:10px;">{{ $t('SetLaboratoryPUEThreshold') }}
                            </el-button>
                            <!--                            <el-button type="success" icon="el-icon-download" style="margin-bottom:10px;">导出Excel-->
                            <!--                            </el-button>-->

                            <el-table ref="multipleTable"
                                      :data="tableData3"
                                      border
                                      stripe
                                      style="width:100%;min-height:200px;">
                                <el-table-column fixed="left"
                                                 type="index"
                                                 :label="$t('SN')"
                                                 width="150">
                                </el-table-column>
                                <el-table-column fixed="left"
                                                 prop="labName"
                                                 :label="$t('LabName')"
                                                 width="170">
                                </el-table-column>

                                <el-table-column :label="$t('PUEThreshold')" align="center">
                                    <el-table-column prop="TUpL1"
                                                     :label="$t('UpperLimit_L1')"
                                                     width="150">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.PUE.upOne}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="TUpL2"
                                                     :label="$t('UpperLimit_L2')"
                                                     width="150">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.PUE.upTwo}}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="TLowerL1"
                                                     :label="$t('LowerLimit_L1')"
                                                     width="150">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.PUE.downOne}}</label>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="TLowerL2"
                                                      :label="$t('LowerLimit_L2')"
                                                     width="150">
                                        <template slot-scope="scope">
                                            <label>{{scope.row.dataValue.PUE.downTwo}}</label>
                                        </template>
                                    </el-table-column>
                                </el-table-column>

                                <el-table-column
                                                 :label="$t('Action')"
                                                 width="150">
                                    <template slot-scope="scope">
                                        <el-button v-if="judge('Notification_Update')" @click="editInfo(scope.row)" type="primary" size="small">
                                          {{ $t('Edit') }}
                                        </el-button>
                                        <template v-if="judge('Notification_Delete')">
                                            <el-popconfirm placement="top"
                                                           :confirmButtonText="$t('Delete')"
                                                           :cancelButtonText="$t('Cancel')"
                                                           @onConfirm="delData(scope.row.notificationObject)"
                                                           icon="el-icon-info"
                                                           iconColor="red"
                                                           :title="$t('DeleteConfirm')">
                                                <el-button size="mini" type="danger" slot="reference"
                                                           style=" margin-left: 10px;">{{ $t('Delete') }}
                                                </el-button>
                                            </el-popconfirm>
                                        </template>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-tab-pane>
                </el-tabs>
                <el-pagination
                        background
                        :page-size="10"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                        :total="pagination.totalPage">
                </el-pagination>
            </el-main>
        </el-scrollbar>

        <el-dialog :title="$t('SetMeterThreshold')" v-if="dialogThresholdValue" :visible.sync="dialogThresholdValue" width="70%"
                   top="10vh">
            <el-form ref="Valueform" :model="Valueform" label-width="120px">
                <el-row :gutter="24">
                    <el-col :xs="24" :sm="12" :md="12" :lg="8">
                        <el-form-item :label="$t('City')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" @change="getFac('add')" v-model="Valueform.cityId">
                                <el-option v-for="(item,index) in area" :key="'inx1'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8">
                        <el-form-item :label="$t('Campus')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" @change="getBuild('add')" v-model="Valueform.factoryId">
                                <el-option v-for="(item,index) in facList" :key="'inx2'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8">
                        <el-form-item :label="$t('Building')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" @change="getLab('add')" v-model="Valueform.buildingId">
                                <el-option v-for="(item,index) in building" :key="'inx3'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8">
                        <el-form-item :label="$t('Lab')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" v-model="Valueform.LabId" @change="getDevide('add')">
                                <el-option v-for="(item,index) in labList" :key="'inx4'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8">
                        <el-form-item :label="$t('ElectricityMeterName')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" v-model="Valueform.deviceId" @change="getDeviceCode()">
                                <el-option v-for="(item,index) in deviveList" :key="'inx5'+index" :value="item.value"
                                           :label="item.label" v-if="item.type=='ElectricMeter'"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="12" :md="12" :lg="8">
                        <el-form-item :label="$t('CurrentMultiplier')">
                            <el-input disabled  v-model="Valueform.magnification"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8">
                        <el-form-item :label="$t('MultipliedByTheMultiplier')">

                            <el-select disabled v-model="Valueform.enableMultiply" >
                                <el-option v-for="(item,index) in tfList" :key="index" :value="item.value"
                                           :label="item.label" ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :xs="24" :sm="12" :md="12" :lg="8">
                        <el-form-item :label="$t('ElectricityMeterCode')">
                            <el-input disabled v-model="Valueform.deviceCode"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-form-item :label="$t('ThresholdSettings')" style="width:100%">
                            <template>
                                <el-table :data="ValueTable"
                                          ref="ValueTable"
                                          border
                                          class="formSTable"
                                          style="width: 100%;">
                                    <el-table-column prop="label"
                                                     :label="$t('Threshold')"
                                                     width="200px">
                                    </el-table-column>
                                    <el-table-column prop="upOne"
                                                     :label="$t('UpperLimitLevel1')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.upOne"></el-input>

                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="upTwo"
                                                     :label="$t('UpperLimitLevel2')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-if ="scope.row.name=='ImbaC'" disabled v-model="scope.row.upTwo"></el-input>
                                            <el-input v-else v-model="scope.row.upTwo"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="downOne"
                                                     :label="$t('LowerLimitLevel1')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-if ="scope.row.name=='ImbaC'|| scope.row.name=='Imba'" disabled v-model="scope.row.downOne"></el-input>
                                            <el-input v-else  v-model="scope.row.downOne"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="downTwo"
                                                     :label="$t('LowerLimitLevel2')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-if ="scope.row.name=='ImbaC'|| scope.row.name=='Imba'" disabled v-model="scope.row.downTwo"></el-input>
                                            <el-input v-else v-model="scope.row.downTwo"></el-input>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item style="text-align: center;width: 100%;">
                    <el-button type="success" :loading="loading" @click="onSubmit">{{ $t('Confirm') }}</el-button>
                    <el-button @click="onCancel">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :title="$t('SetTemperatureAndHumidityThreshold')" :visible.sync="dialogTumValue" width="70%" top="10vh">
            <el-form ref="Valueform" :model="Valueform" label-width="120px">
                <el-row :gutter="24">
                    <el-col :xs="24" :sm="12" :md="12" :lg="12">
                        <el-form-item :label="$t('City')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" @change="getFac('add')" v-model="Valueform.cityId">
                                <el-option v-for="(item,index) in area" :key="'inx1'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12">
                        <el-form-item :label="$t('Campus')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" @change="getBuild('add')" v-model="Valueform.factoryId">
                                <el-option v-for="(item,index) in facList" :key="'inx2'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12">
                        <el-form-item :label="$t('Building')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" @change="getLab('add')" v-model="Valueform.buildingId">
                                <el-option v-for="(item,index) in building" :key="'inx3'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12">
                        <el-form-item :label="$t('Lab')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" v-model="Valueform.LabId" @change="getDevide('add')">
                                <el-option v-for="(item,index) in labList" :key="'inx4'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12">
                        <el-form-item :label="$t('THMeterName')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" v-model="Valueform.deviceId" @change="getDeviceCode()">
                                <el-option v-for="(item,index) in deviveList" :key="'inx5'+index" :value="item.value"
                                           :label="item.label" v-if="item.type=='TemHumSensor'"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12">
                        <el-form-item :label="$t('THMeterCode')">
                            <el-input disabled v-model="Valueform.deviceCode"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-form-item :label="$t('ThresholdSettings')" style="width:100%">
                            <template>
                                <el-table :data="ValueTableTum"
                                          ref="ValueTable"
                                          border
                                          class="formSTable"
                                          style="width: 100%;">
                                    <el-table-column prop="label"
                                                     :label="$t('Threshold')"
                                                     width="200px">
                                    </el-table-column>
                                    <el-table-column prop="upOne"
                                                     :label="$t('UpperLimitLevel1')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.upOne"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="upTwo"
                                                     :label="$t('UpperLimitLevel2')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.upTwo"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="downOne"
                                                     :label="$t('LowerLimitLevel1')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.downOne"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="downTwo"
                                                     :label="$t('LowerLimitLevel2')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.downTwo"></el-input>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item style="text-align: center;width: 100%;">
                    <el-button type="success" @click="onSubmit">{{ $t('Confirm') }}</el-button>
                    <el-button @click="onCancel">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
         <el-dialog :title="$t('SetPUEThreshold')" :visible.sync="dialogPUEValue" width="70%" top="10vh">
            <el-form ref="Valueform" :model="Valueform" label-width="120px">
                <el-row :gutter="24">
                    <el-col :xs="24" :sm="12" :md="12" :lg="12">
                        <el-form-item :label="$t('City')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" @change="getFac('add')" v-model="Valueform.cityId">
                                <el-option v-for="(item,index) in area" :key="'inx1'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12">
                        <el-form-item :label="$t('Campus')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" @change="getBuild('add')" v-model="Valueform.factoryId">
                                <el-option v-for="(item,index) in facList" :key="'inx2'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12">
                        <el-form-item :label="$t('Building')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" @change="getLab('add')" v-model="Valueform.buildingId">
                                <el-option v-for="(item,index) in building" :key="'inx3'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12">
                        <el-form-item :label="$t('Lab')">
                            <el-select :placeholder="$t('el.select.placeholder')" :disabled="intputDisa" v-model="Valueform.LabId" @change="getDevide('add')">

                                <el-option v-for="(item,index) in labList" :key="'inx4'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-form-item :label="$t('ThresholdSettings')" style="width:100%">
                            <template>
                                <el-table :data="ValueTablePue"
                                          ref="ValueTable"
                                          border
                                          class="formSTable"
                                          style="width: 100%;">
                                    <el-table-column prop="label"
                                                     :label="$t('Threshold')"
                                                     width="200px">
                                    </el-table-column>
                                    <el-table-column prop="upOne"
                                                     :label="$t('UpperLimitLevel1')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.upOne"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="upTwo"
                                                     :label="$t('UpperLimitLevel2')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.upTwo"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="downOne"
                                                     :label="$t('LowerLimitLevel1')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.downOne"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="downTwo"
                                                     :label="$t('LowerLimitLevel2')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.downTwo"></el-input>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item style="text-align: center;width: 100%;">
                    <el-button type="success" @click="onSubmit">{{ $t('Confirm') }}</el-button>
                    <el-button @click="onCancel">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import areaSelect from '../../components/content/maintabber/areaSelect'
    import {mapState} from 'vuex';
    import {GetAllNotification, CreateNotification, DeleteNotification, UpdateNotification,getElectricInfoById} from '../../api/api'
    import {fancha, getDeviceNameByid} from '../../utils/util'
    import {judgePermission} from '../../utils/util'
    export default {
        name: "threshold",
        components:{
            areaSelect
        },
        data() {
            return {
                level:5,
                deviceType:"",
                deviceType1:"",
                loading: false,
                dialogThresholdValue: false,
                dialogTumValue: false,
                dialogPUEValue:false,
                tableData1: [
                    // {
                    //     ID: '234213',
                    //     name: '电表00212',
                    //     dataValue: {
                    //         PF: {upOne: "", upTwo: "", downOne: "", downTwo: ""},
                    //         W: {upOne: "", upTwo: "", downOne: "", downTwo: ""},
                    //         Ia: {upOne: "", upTwo: "", downOne: "", downTwo: ""},
                    //         Ib: {upOne: "", upTwo: "", downOne: "", downTwo: ""},
                    //         Ic: {upOne: "", upTwo: "", downOne: "", downTwo: ""},
                    //         S: {upOne: "", upTwo: "", downOne: "", downTwo: ""},
                    //         Uan: {upOne: "", upTwo: "", downOne: "", downTwo: ""},
                    //         Ubn: {upOne: "", upTwo: "", downOne: "", downTwo: ""},
                    //         Ucn: {upOne: "", upTwo: "", downOne: "", downTwo: ""},
                    //         Ep: {upOne: "", upTwo: "", downOne: "", downTwo: ""},
                    //     }
                    // }
                ],
                tableData2: [],
                tableData3: [],
                activeName: "first",

                area: JSON.parse(sessionStorage.getItem("area")),
                formArea: {cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""},
                formselect: {cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""},
                facList: [],
                building: [],
                labList: [],
                deviveList: [],

                Valueform: {
                    id: "",
                    countryId: '',
                    cityId: '',
                    factoryId: '',
                    buildingId: '',
                    LabId: '',
                    deviceId: "",
                    deviceCode: "",
                    name: '',
                },
                country: [{
                    value: '1',
                    label: '中国'
                }],
                city: [],
                clickBtn: "",
                pack: [],
                buiilding: [],
                lab: [],
                ValueTableTum: [
                    {
                        label: this.$t('Temperature'),
                        name: "Temp",
                        upOne: "",
                        upTwo: "",
                        downOne: "",
                        downTwo: ""
                    }, {
                        label: this.$t('Humidity'),
                        name: "Hum",
                        upOne: "",
                        upTwo: "",
                        downOne: "",
                        downTwo: ""
                    }],
                ValueTable: [
                    {
                        label: this.$t('PowerFactor'),
                        name: "PF",
                        upOne: "",
                        upTwo: "",
                        downOne: "",
                        downTwo: ""
                    }, {
                        label: this.$t('InstantaneousTotalPower') + '(KW)',
                        name: "W",
                        upOne: "",
                        upTwo: "",
                        downOne: "",
                        downTwo: ""
                    },
                    {
                        label: this.$t('PhaseACurrent') + '(A)',
                        name: "Ia",
                        upOne: "",
                        upTwo: "",
                        downOne: "",
                        downTwo: ""
                    },
                    {
                        label: this.$t('PhaseBCurrent') + '(A)',
                        name: "Ib",
                        upOne: "",
                        upTwo: "",
                        downOne: "",
                        downTwo: ""
                    },
                    {
                        label: this.$t('PhaseCCurrent') + '(A)',
                        name: "Ic",
                        upOne: "",
                        upTwo: "",
                        downOne: "",
                        downTwo: ""
                    },
                    {
                        label: this.$t('PhaseAVoltage') + '(V)',
                        name: "Uan",
                        upOne: "",
                        upTwo: "",
                        downOne: "",
                        downTwo: ""
                    },
                    {
                        label: this.$t('PhaseBVoltage') + '(V)',
                        name: "Ubn",
                        upOne: "",
                        upTwo: "",
                        downOne: "",
                        downTwo: ""
                    },
                    {
                        label: this.$t('PhaseCVoltage ') + '(V)',
                        name: "Ucn",
                        upOne: "",
                        upTwo: "",
                        downOne: "",
                        downTwo: ""
                    },
                    {
                        label: this.$t('ApparentPower') + '(KVA)',
                        name: "S",
                        upOne: "",
                        upTwo: "",
                        downOne: "",
                        downTwo: ""
                    },
                    // {
                    //     label: this.$t('AccumulatedConsumptionThreshold') + '(EP)',
                    //     name: "Ep",
                    //     upOne: "",
                    //     upTwo: "",
                    //     downOne: "",
                    //     downTwo: ""
                    // },
                     {
                        label: this.$t('Three-phaseUnbalance'),
                        name: "Imba",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('Three-phaseUnbalanceCurrentCondition'),
                        name: "ImbaC",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    ],
                ValueTablePue:[
                    {
                        label: 'PUE',
                        name: "PUE",
                        upOne: "",
                        upTwo: "",
                        downOne: "",
                        downTwo: ""
                    },
                ],
                pagination: {
                    current: 1,
                    pageSize: 10,
                    totalPage: 0
                },
                tfList:[
                    {value:true,label: this.$t('yes')},
                    {value:false,label: this.$t('No')}
                ],
                intputDisa:false
            }
        },

        mounted() {
            // console.log(this.area)
             if(this.activeName=='first'){
                this.deviceType ='ElectricMeter'
            }else{
                this.deviceType ='TemHumSensor'
            }
            this.getData()
        },
        methods: {
            judge(e){
                return judgePermission(e)
            },
            getAreaList(e){
           
                this.formselect = {...this.formselect,...e.Valueform}
            },
            handleClick() {
           
                 if(this.activeName=='first'){
                    this.deviceType ='ElectricMeter'
                }else if(this.activeName =='second') {
                    this.deviceType ='TemHumSensor'
                }else {
                     this.deviceType ='LabPue'
                }
                this.Valueform = {
                    id: "",
                    countryId: '',
                    cityId: '',
                    factoryId: '',
                    buildingId: '',
                    LabId: '',
                    deviceId: "",
                    deviceCode: '',
                    name: '',
                    magnification:'',
                    enableMultiply:''
                }
                this.pagination.current = 1
                this.reset()
            },
            //分页数据
            handleCurrentChange(val) {
                this.pagination.current = val;
                this.getData()
            },

            dataReset(){
                this.ValueTable = [
                    {
                        label: this.$t('PowerFactor'),
                        name: "PF",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    }, {
                        label: this.$t('InstantaneousTotalPower') + '(KW)',
                        name: "W",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('PhaseACurrent') + '(A)',
                        name: "Ia",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('PhaseBCurrent') + '(A)',
                        name: "Ib",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('PhaseCCurrent') + '(A)',
                        name: "Ic",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('PhaseAVoltage') + '(V)',
                        name: "Uan",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('PhaseBVoltage') + '(V)',
                        name: "Ubn",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('PhaseCVoltage ') + '(V)',
                        name: "Ucn",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('ApparentPower') + '(KVA)',
                        name: "S",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    // {
                    //     label: '累计电量值(EP)',
                    //     name: "Ep",
                    //     upOne: "-1",
                    //     upTwo: "-1",
                    //     downOne: "-1",
                    //     downTwo: "-1"
                    // },
                    {
                        label: this.$t('Three-phaseUnbalance'),
                        name: "Imba",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('Three-phaseUnbalanceCurrentCondition'),
                        name: "ImbaC",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    ]
                this.ValueTableTum = [
                    {
                        label: this.$t('Temperature'),
                        name: "Temp",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    }, {
                        label: this.$t('Humidity'),
                        name: "Hum",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    }]
                this.ValueTablePue =[
                    {
                        label: 'PUE',
                        name: "PUE",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    }
                ]

            },
            //新增
            add() {
                this.clickBtn = 'add'
                this.intputDisa = false
                this.Valueform = {
                    id: "",
                    countryId: '',
                    cityId: '',
                    factoryId: '',
                    buildingId: '',
                    LabId: '',
                    deviceId: "",
                    deviceCode: '',
                    name: '',
                }
                this.dataReset()


                if (this.activeName == 'first') {
                   this.dialogThresholdValue = true
                } else if(this.activeName =='second') {
                    this.dialogTumValue = true
                }else{
                    this.dialogPUEValue = true
                }
            },
            //删除
            delData(e) {
         
                var that = this
                DeleteNotification(e).then(res => {
                    if (res.success) {
                        that.$message.success(this.$t('deleteSuccessful'))
                        that.reset()
                    } else {
                        that.$message.error(this.$t('DeleteFailed'))
                    }
                })
            },
            //修改
            editInfo(e) {
                 
                this.intputDisa = true
                this.Valueform.cityId=''
                this.Valueform.factoryId=''
                this.Valueform.buildingId=''
                this.Valueform.LabId=''
                this.Valueform.deviceId=''
                this.Valueform.deviceCode=''
                this.Valueform.magnification = e.magnification
                this.Valueform.enableMultiply = e.enableMultiply
                this.clickBtn = 'edit'
                var data = fancha(e.notificationObject)
                // console.log(data)
                for (var i in data) {
                    switch (i) {
                        case "0":
                            this.Valueform.cityId = this.area[data[i]].value
                            this.facList = this.area[data[i]].children
                            break;
                        case "1":
                            this.Valueform.factoryId = this.facList[data[i]].value
                            this.building = this.facList[data[i]].children
                            break;
                        case "2":
                            this.Valueform.buildingId = this.building[data[i]].value
                            this.labList = this.building[data[i]].children
                            break;
                        case "3":
                            this.Valueform.LabId = this.labList[data[i]].value
                            this.deviveList = this.labList[data[i]].children
                            break;
                        case "4":
                            this.Valueform.deviceId = this.deviveList[data[i]].value
                            break;
                    }
                }
                // console.log(e)
                this.Valueform.id = e.id
                this.Valueform.deviceId = e.notificationObject
                this.Valueform.deviceCode = e.deviceCode
                if (this.activeName == 'first') {
                    this.dialogThresholdValue = true
                    this.ValueTable.map((item, index) => {
                        e.typeValueList.map((j, k) => {
                            if (item.name == j.name ) {
                                item.upOne = j.upOne
                                item.upTwo = j.upTwo
                                item.downOne = j.downOne
                                item.downTwo = j.downTwo

                            }
                        })
                    })
                } else if (this.activeName == 'second'){
                    this.dialogTumValue = true
                    this.ValueTableTum.map((item, index) => {
                        e.typeValueList.map((j, k) => {
                            if (item.name == j.name) {
                                item.upOne = j.upOne
                                item.upTwo = j.upTwo
                                item.downOne = j.downOne
                                item.downTwo = j.downTwo
                            }
                        })
                    })
                }else{
                    this.dialogPUEValue = true
                    this.ValueTablePue.map((item, index) => {
                        e.typeValueList.map((j, k) => {
                            if (item.name == j.name) {
                                item.upOne = j.upOne
                                item.upTwo = j.upTwo
                                item.downOne = j.downOne
                                item.downTwo = j.downTwo
                            }
                        })
                    })
                }
            },
            //

            getFac(e) {
                var a = '', id = e == 'add' ? this.Valueform.cityId : this.formArea.cityId
                this.area.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.facList = this.area[a].children
                this.formArea = {...this.formArea, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}
                this.Valueform = {...this.Valueform, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}
            },
            getBuild(e) {
                var a = '', id = e == 'add' ? this.Valueform.factoryId : this.formArea.factoryId
                this.facList.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.building = this.facList[a].children
                this.formArea = {...this.formArea, ...{buildingId: "", LabId: "", deviceId: ""}}
                this.Valueform = {...this.Valueform, ...{buildingId: "", LabId: "", deviceId: ""}}
            },
            getLab(e) {
                var a = '', id = e == 'add' ? this.Valueform.buildingId : this.formArea.buildingId
                this.building.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.labList = this.building[a].children
                this.labList.map(item=>{
                    if(item.value=="00000000-0000-0000-0000-000000000000"){
                        item.label = this.$t('NonLaboratory')
                    }
                })
                this.formArea = {...this.formArea, ...{LabId: "", deviceId: ""}}
                this.Valueform = {...this.Valueform, ...{LabId: "", deviceId: ""}}
            },
            getDeviceCode(){
             this.dataReset()
                this.Valueform.magnification = ''
                this.Valueform.enableMultiply = ''
     
                this.deviveList.map(item=>{
                    if(item.value==this.Valueform.deviceId){
                        this.Valueform.deviceCode = item.code
                    }
                })
                 
                this.formselect.cityId = this.Valueform.cityId
                this.formselect.factoryId = this.Valueform.factoryId
                this.formselect.buildingId = this.Valueform.buildingId
                this.formselect.LabId = this.Valueform.LabId
                this.formselect.deviceId = this.Valueform.deviceId
                var that = this

                var data = this.formselect
                if (this.activeName == 'first') {
                    data.deviceType = 'ElectricMeter'
                } else {
                    data.deviceType = 'TemHumSensor'
                }
                GetAllNotification(data, 'id', 5, 0).then(res => {
                    if (res.success) {
                         
                        var list = res.result
                          this.intputDisa = true
                        if(list.items.length>0){
                            if (this.activeName == 'first') {

                                this.Valueform.magnification = list.items[0].magnification
                                this.Valueform.enableMultiply = list.items[0].enableMultiply
                                     this.intputDisa = false
                        
                                this.ValueTable.map((item, index) => {
                                    list.items[0].typeValueList.map((j, k) => {
                                        if (item.name == j.name ) {
                                            item.upOne = j.upOne
                                            item.upTwo = j.upTwo
                                            item.downOne = j.downOne
                                            item.downTwo = j.downTwo

                                        }
                                    })
                                })
                            } else {
                                this.ValueTableTum.map((item, index) => {
                                    list.items[0].typeValueList.map((j, k) => {
                                        if (item.name == j.name) {
                                            item.upOne = j.upOne
                                            item.upTwo = j.upTwo
                                            item.downOne = j.downOne
                                            item.downTwo = j.downTwo
                                        }
                                    })
                                })
                            }
                            //that.$message.warning("已存在相同阈值配置")
                        }else{
                            getElectricInfoById(this.formselect.deviceId).then(r=>{
                                if(r.success){
                                    var info = r.result
                               
                                    this.Valueform.magnification = r.result.magnification
                                    this.Valueform.enableMultiply = r.result.enableMultiply
                                         this.intputDisa = false
                                }
                            })
                        }

                    } else {
                        that.$message.error(this.$t('failed'))
                    }
                })
            },
            getDevide(e) {
                var a = '', id = e == 'add' ? this.Valueform.LabId : this.formArea.LabId
                this.labList.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.deviveList = this.labList[a].children
                this.formArea = {...this.formArea, ...{deviceId: ""}}
                this.Valueform = {...this.Valueform, ...{deviceId: ""}}
            },

            getData() {
                 
                var that = this
                let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
                var data = this.formselect
                if (this.activeName == 'first') {
                    data.deviceType = 'ElectricMeter'
                } else if(this.activeName =='second') {
                    data.deviceType = 'TemHumSensor'
                }else{
                    data.deviceType = 'LabPue'
                }

                GetAllNotification(data, 'id', this.pagination.pageSize, skipcount).then(res => {

                    if (res.success) {
                        var data = res.result
                        data.items.map((i, k) => {
                            var value = {}
                            i.index = k + 1
                            i.typeValueList.map(j => {
                                value[j.name] = {
                                    upOne: j.upOne,
                                    upTwo: j.upTwo,
                                    downOne: j.downOne,
                                    downTwo: j.downTwo
                                }
                            })
                            i.dataValue = value
                        })
                        that.$nextTick(function () {
                            if (this.activeName == 'first') {
                                that.tableData1 = data.items
                            } else if(this.activeName == 'second') {
                                that.tableData2 = data.items
                            }else {
                                that.tableData3 = data.items
                            }
                        })
                        that.pagination.totalPage = res.result.totalCount
                    } else {
                        that.$message.error(this.$t('failed'))
                    }
                })
            },
            reset() {
                this.formArea = {cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""}
                this.formselect= {cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""}
                this.getData()
            },
            onSubmit() {
                this.loading = true

                var data = {
                    objectType: '',
                    typeValueList: '',
                    notificationObject: this.Valueform.deviceId,
                }
                if (this.activeName == 'first') {
                    data.objectType = 'ElectricMeter'
                    data.typeValueList = this.ValueTable
                } else if(this.activeName == 'second') {
                    data.objectType = 'TemHumSensor'
                     data.typeValueList = this.ValueTableTum
                }else{
                    data.objectType = 'LabPue'
                    data.typeValueList = this.ValueTablePue
                    data.notificationObject = this.Valueform.LabId
                }

                if(this.activeName != 'third'){
                    if (this.deviveList.length > 0) {
                        this.deviveList.map((item, index) => {
                            if (this.Valueform.deviceId == item.value) {
                                data.remark = item.label
                                data.deviceName = item.label
                            }
                        })
                    }
                }

                data.typeValueList.map((j, k) => {
                    if(j.name =="W"|| j.name =="S"|| j.name =="Ia"|| j.name =="Ib"|| j.name =="Ic" ){


                        if(j.upOne>0 && this.Valueform.enableMultiply==true){
                            j.upOne = j.upOne*100/this.Valueform.magnification/100
                        }else{
                                j.upOne = j.upOne
                        }
                        if(j.upTwo>0 && this.Valueform.enableMultiply==true){
                            j.upTwo = j.upTwo*100/this.Valueform.magnification/100
                        }else{
                            j.upTwo = j.upTwo
                        }
                        if(j.downOne>0 && this.Valueform.enableMultiply==true){
                            j.downOne = j.downOne*100/this.Valueform.magnification/100
                        }else{
                                j.downOne = j.downOne
                        }
                        if(j.downTwo>0 && this.Valueform.enableMultiply==true){
                            j.downTwo = j.downTwo*100/this.Valueform.magnification/100
                        }else{
                                j.downTwo = j.downTwo
                        }
                    }
                })

                if (this.Valueform.id) {
                    data.id = this.Valueform.id
                    UpdateNotification(data).then(res => {
                       
                        if (res.success) {
                            this.$message.success(this.$t('SuccessfullySaved'))
                            this.loading = false
                            this.dialogThresholdValue = false
                            this.dialogTumValue = false
                            this.dialogPUEValue = false
                            this.reset()
                        } else {
                            this.loading = false
                            this.$message.success(this.$t('SaveFailed'))
                        }
                    })
                } else {
                    delete data.id
                    CreateNotification(data).then(res => {               
                        if (res.success) {
                            this.$message.success(this.$t('SuccessfullySaved'))
                            this.loading = false
                            this.dialogThresholdValue = false
                            this.dialogTumValue = false
                            this.dialogPUEValue = false
                            this.reset()
                        } else {
                            this.loading = false
                            this.$message.success(this.$t('SaveFailed'))
                        }
                    })
                }
            },
            onCancel(){
                this.ValueTable = [
                    {
                        label: this.$t('PowerFactor'),
                        name: "PF",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    }, {
                        label: this.$t('InstantaneousTotalPower') + '(KW)',
                        name: "W",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('PhaseACurrent') + '(A)',
                        name: "Ia",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('PhaseBCurrent') + '(A)',
                        name: "Ib",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('PhaseCCurrent') + '(A)',
                        name: "Ic",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('PhaseAVoltage') + '(V)',
                        name: "Uan",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('PhaseBVoltage') + '(V)',
                        name: "Ubn",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('PhaseCVoltage ') + '(V)',
                        name: "Ucn",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('ApparentPower') + '(KVA)',
                        name: "S",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    // {
                    //     label: this.$t('AccumulatedConsumptionThreshold') + '(EP)',
                    //     name: "Ep",
                    //     upOne: "-1",
                    //     upTwo: "-1",
                    //     downOne: "-1",
                    //     downTwo: "-1"
                    // },
                    {
                        label: this.$t('Three-phaseUnbalance'),
                        name: "Imba",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    {
                        label: this.$t('Three-phaseUnbalanceCurrentCondition'),
                        name: "ImbaC",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    },
                    ]
                this.ValueTableTum = [
                    {
                        label: this.$t('Temperature'),
                        name: "Temp",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    }, {
                        label: this.$t('Humidity'),
                        name: "Hum",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    }]

                this.ValueTablePue =[
                    {
                        label: 'PUE',
                        name: "PUE",
                        upOne: "-1",
                        upTwo: "-1",
                        downOne: "-1",
                        downTwo: "-1"
                    }
                ]
                this.dialogThresholdValue = false
                this.dialogTumValue = false
                this.dialogPUEValue = false
            }
        },
        computed: mapState({
            isCollapse: state => state.isCollapse
        }),
    }
</script>

<style scoped>

</style>
